import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class EventObservabilityService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getSummary() {
        try {
            const body = await withRetry(() => this.api.getSummary(), { maxRetries: 2 });
            return { success: body.success !== false, data: body.data, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Event özeti alınamadı');
        }
    }

    async getRecentActivity(params = {}) {
        try {
            const body = await withRetry(() => this.api.getRecentActivity(params), { maxRetries: 2 });
            return {
                success: body.success !== false,
                data: body.data,
                meta: body.meta || {},
                message: body.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Event aktivitesi alınamadı');
        }
    }

    async getTopEvents(params = {}) {
        try {
            const body = await withRetry(() => this.api.getTopEvents(params), { maxRetries: 2 });
            return { success: body.success !== false, data: body.data, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Event istatistikleri alınamadı');
        }
    }

    async getWorkerHealth() {
        try {
            const body = await withRetry(() => this.api.getWorkerHealth(), { maxRetries: 2 });
            return { success: body.success !== false, data: body.data, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Worker sağlık durumu alınamadı');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
